import { loadStripe } from "@stripe/stripe-js";
import { StripeCopy } from "@/enums";

/**
 * Initializes and mounts Stripe Embedded Checkout into the given DOM element.
 * Returns the embeddedCheckout instance so the caller can destroy it on unmount.
 */
export async function initStripeCheckout(clientSecret, mountEl) {
  const publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;

  if (!publishableKey) {
    throw new Error(StripeCopy.MANAGE_SUBSCRIPTION.MISSING_PUBLISHABLE_KEY);
  }

  const stripe = await loadStripe(publishableKey);

  if (!stripe) {
    throw new Error(StripeCopy.MANAGE_SUBSCRIPTION.STRIPE_LOAD_FAILED);
  }

  const embeddedCheckout = await stripe.initEmbeddedCheckout({ clientSecret });

  if (!mountEl) {
    throw new Error(StripeCopy.MANAGE_SUBSCRIPTION.CHECKOUT_CONTAINER_NOT_FOUND);
  }

  embeddedCheckout.mount(mountEl);

  return embeddedCheckout;
}